import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";
import { HeaderLogoAndTel } from "../../../components/HeaderLogoAndTel";
import {
  WhomEng,
  EducationEng,
  OfferEng,
  AttentionEng,
  ReviewsVideo,
  CostEng,
  main
} from "../../../components/LandingTemplates/kuratorskoe_soprovozhdenie";
import * as screen1 from "./styles/screen1.module.scss";
import reviewsData from "./data/reviews.json";
const Screen1 = () => {
  return (
    <header className={screen1.screen1}>
      <div className="container">
        <HeaderLogoAndTel/>
        <div className={screen1.screen1__wrapper}>
          <div className={screen1.screen1__titleWrapper}>
            <h1 className={screen1.screen1__title}>Кураторское сопровождение курса &laquo;Фонетика английского языка&raquo;</h1>
            <h2 className={screen1.screen1__subtitle}>За&nbsp;20&nbsp;дней заговорите без акцента, благодаря обратной связи,
              дедлайнам и&nbsp;контролю<br/> со&nbsp;стороны куратора</h2>
          </div>
          <div className={screen1.screen1__linkWrapper}>
            <a className={`${screen1.screen1__link} ${main.mainBtn}`} href="#cost" data-target="#course">
              Оставить заявку
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};
const TITLE = 'Кураторское сопровождение курса «Фонетика английского языка»';
const DESCRIPTION = 'За 20 дней заговорите без акцента, благодаря обратной связи, дедлайнам и контролю со стороны куратора';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1/>
      <WhomEng
        video={"https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie_fonetika/video/Screencast_chata_fonetika.mp4"}
        poster={"https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie_fonetika/phone-screencast-phonetic.png"}
        duration={"20 учебных дней"}
      />
      <EducationEng/>
      <OfferEng/>
      <AttentionEng
        imgSrc={"https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie_fonetika/iphone-hand.png"}
      />
      <ReviewsVideo
        data={reviewsData}
        courseName={"Фонетика английского языка"}
        vidSrc={"https://65395.servicecdn.ru/videos/65395_iJrPCINcc6pkRdo"}
      />
      <CostEng
        widget={<GetCourseWidget hash={'85be293f8aa49423ecfea61131c528a6639e0bee'} id={'681296'}/>}
        price={"5\u00A0000\u00A0₽"}
        imgSrc={"https://fs.advance.ru/landing-pages/inostrannye_yazyki/kuratorskoe_soprovozhdenie_fonetika/iphone-price.png"}
      />
    </main>

    <FooterMedium/>
  </DefaultLayout>
);
export default Page;
